import {
  Button,
  column,
  dateColumn,
  GridColumn,
  GridDataRow,
  GridTable,
  RowStyles,
  simpleDataRows,
  SimpleHeaderAndData,
  useModal,
} from "@homebound/beam";
import { Price } from "src/components";
import { FundLoanManagementPageInvoiceFragment } from "src/generated/graphql-types";
import { createInvoiceDetailsUrl } from "src/RouteUrls";
import { formatWithYear } from "src/utils/dates";
import { CreateInvoiceModal } from "./CreateInvoiceModal";

export type FundInvoicesTableProps = {
  invoices: FundLoanManagementPageInvoiceFragment[];
  fundId: string;
};

export function FundInvoicesTable(props: FundInvoicesTableProps) {
  const { invoices, fundId } = props;

  const { openModal } = useModal();

  return (
    <>
      <GridTable
        id="invoicesTable"
        rowStyles={rowStyles}
        columns={createInvoiceColumns()}
        rows={createInvoiceRows(invoices)}
        fallbackMessage="Invoices for this Fund will show here."
      />
      <Button
        label="Create Invoice"
        variant="secondary"
        onClick={() =>
          openModal({
            content: <CreateInvoiceModal fundId={fundId} />,
          })
        }
      />
    </>
  );
}

type Row = SimpleHeaderAndData<FundLoanManagementPageInvoiceFragment>;

const rowStyles: RowStyles<Row> = {
  header: {},
  data: {
    onClick: ({ data }) => {
      window.open(`${createInvoiceDetailsUrl(data.id)}`, "_blank", "noopener,noreferrer");
    },
  },
};

function createInvoiceRows(invoices: FundLoanManagementPageInvoiceFragment[]): GridDataRow<Row>[] {
  return simpleDataRows(invoices);
}

function createInvoiceColumns(): GridColumn<Row>[] {
  const idColumn = column<Row>({
    header: () => "Credit Facility Invoice ID",
    data: ({ id }) => id,
  });

  const invoiceDateColumn = dateColumn<Row>({
    header: () => "Invoice Date",
    data: ({ invoiceDate }) => formatWithYear(invoiceDate),
  });

  const amountColumn = column<Row>({
    header: () => "Amount Invoiced",
    data: ({ amountInCents }) => getPriceComponent(amountInCents),
  });

  return [idColumn, invoiceDateColumn, amountColumn];
}

function getPriceComponent(value: number | undefined) {
  return <Price valueInCents={value} dropZero />;
}
